import { render } from "./CruAks.vue?vue&type=template&id=4de43db4&scoped=true&ts=true"
import script from "./CruAks.vue?vue&type=script&lang=ts"
export * from "./CruAks.vue?vue&type=script&lang=ts"

import "./CruAks.vue?vue&type=style&index=0&id=4de43db4&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de43db4"]])

export default __exports__